module.exports = __webpack_public_path__ + "static/media/3.7c9efa17.jpg";